import { render, staticRenderFns } from "./ServerTable.vue?vue&type=template&id=a9d1a482&scoped=true"
import script from "./ServerTable.vue?vue&type=script&lang=js"
export * from "./ServerTable.vue?vue&type=script&lang=js"
import style0 from "./ServerTable.vue?vue&type=style&index=0&id=a9d1a482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d1a482",
  null
  
)

export default component.exports